import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IGetInterventionDocumentsRequestAction {
  data: {
    id: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function getDocumentsRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IGetInterventionDocumentsRequestAction>,
) {
  draft.getDocuments.config.isLoading = true;
}

export default getDocumentsRequest;
